import React, { Component } from 'react';
import './App.scss';
import Header from './components/header/Header';
import Test from './components/test/Test';
import questionnare from 'assets/conflict-management-styles';
import { Switch, Route, Redirect } from 'react-router-dom';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />

        <Switch>
          <Route
            exact
            path="/"
            render={() => <Test questionnare={questionnare} />}
          />
          {/*<Redirect from="/" to="/" />*/}
        </Switch>
      </div>
    );
  }
}

export default App;
